 // Hide “Brand” filter on all collections accept on watches: =============================================================================
document.addEventListener("DOMContentLoaded", function() {
    var brandFilter = document.querySelector('[data-collapsible-id="filter-brand"]');
    if (brandFilter && !window.location.pathname.includes("/collections/rolex") && !window.location.pathname.includes("/collections/tudor")  && !window.location.pathname.includes("/collections/luxury-pre-owned-watches")) {
        brandFilter.style.display = "none";
    }  
});


 // Remove the word "ESTATE - " from the various brands in the Brand filter on collection pages ===============================================================
document.addEventListener("DOMContentLoaded", function () {
    function removeFilterText() {
        // Remove "ESTATE - " from brand filters
        document.querySelectorAll('[data-collapsible-id="filter-brand"] .tag__checkbox-wrapper .tag__text').forEach(function (element) {
            if (element.textContent.trim().startsWith("ESTATE - ")) {
                element.textContent = element.textContent.trim().replace("ESTATE - ", ""); 
            }
        });
        
        // Remove "Website: " from product type filters
        document.querySelectorAll('[data-collapsible-id="filter-product-type"] .tag__checkbox-wrapper .tag__text').forEach(function (element) {
            if (element.textContent.trim().includes("Website: ")) {
                element.textContent = element.textContent.trim().replace("Website: ", ""); 
            }
        });
    }

    // Run once on initial load
    removeFilterText();

    // Monitor AJAX updates using a MutationObserver
    let observer = new MutationObserver(function (mutations) {
        let shouldUpdate = false;
        
        mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
                shouldUpdate = true;
            }
        });
        
        if (shouldUpdate) {
            removeFilterText(); // Run script again when filters update
        }
    });

    // Observe the entire document for filter updates
    let targetNode = document.body; 
    let config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
});




// Filters in sidebar - Convert the text to capitalize the first letter =================================================================/ 
document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll('#CollectionSidebar .filter-form li label .tag__text'); // Target only the text span

    elements.forEach(function (item) {
        item.textContent = item.textContent.toLowerCase().replace(/(?:^|\s)\S/g, function (match) {
            return match.toUpperCase();
        });
    });
});

// Custom product collection Slider ======================================================
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.product-slider');
    
    sliders.forEach(slider => {
      // Initialize Flickity if not already initialized
      if (!slider.flickity) {
        const options = JSON.parse(slider.getAttribute('data-flickity') || '{}');
        new Flickity(slider, options);
      }
    });
  });





